import { render, staticRenderFns } from "./BlockType16.vue?vue&type=template&id=fb13d260&scoped=true"
import script from "./BlockType16.vue?vue&type=script&lang=ts"
export * from "./BlockType16.vue?vue&type=script&lang=ts"
import style0 from "./BlockType16.vue?vue&type=style&index=0&id=fb13d260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb13d260",
  null
  
)

export default component.exports